<template>
	<div class="commodity">
		<EsHeaderView />
		<div class="app-container app-center">
			<div class="commodity-wrap flex-start">
				<EsFilterView @filterChange="filterChange" />
				<div class="commodity-content">
					<EsSortView @sort="onOrder" :isRenew="isRenew" />
					<div v-loading="loading">
						<div class="commodity-content-list" ref="activeScoll">
							<EsProductView v-for="(item, index) in objsList" :key="index" :item="item" />
						</div>
						<div class="no-data" v-if="!objsList.length">
							<el-empty :description="$t('message.home.noData')"></el-empty>
						</div>
						<div class="common-pagination" v-if="objsList.length">
							<el-pagination background class="es-pagination" layout="total,prev, pager, next"
								:page-size="queryParams.pageSize" :pager-count="5"
								:current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<EsFooterView />
	</div>
</template>

<script>
import EsProductView from "@/components/product";
import EsFilterView from "./filter.vue";
import EsSortView from "./sort.vue";
// import { isEmpty } from "lodash";
import { mapActions, mapGetters } from "vuex";

//////////////////////////////////////////////////////////////////////////////////////////////////

import {
	list,
	search
} from "@/api/goods/goods.js"

//////////////////////////////////////////////////////////////////////////////////////////////////

export default {
	name: "EsCommodity",
	components: { EsProductView, EsSortView, EsFilterView },
	data() {
		return {
			loading: false,
			pageNum: 1,
			isRenew: false,
			pageSize: 20,
			total: 0,
			beforeSortParams: {},
			sort: [],
			scrollTop: 0,
			////////////////////////////////////////////////////////////////////////////////////////////
			currentPage: 1,
			// 设置加载的第几次，默认是第一次  
			//返回数据的个数  
			orderBy: "",
			//排序字段
			orderType: "",
			//排序 asc正 desc反
			searchLoading: false,
			//"上拉加载"的变量，默认false，隐藏  
			searchLoadingComplete: false,
			//“没有数据”的变量，默认false，隐藏 

			gc_id: '',
			goods_name: '',
			activeIndex: 0,
			bannerApp: true,
			winWidth: 0,
			winHeight: 0,
			currentTab: 0,
			//tab切换  
			goodsId: 0,
			itemData: {},
			bannerItem: [],
			buynum: 1,
			// 产品图片轮播
			indicatorDots: true,
			autoplay: true,
			interval: 5000,
			duration: 1000,
			// 属性选择
			firstIndex: -1,
			//准备数据
			//数据结构：以一组一组来进行设定
			commodityAttr: [],
			attrValueList: [],
			animationData: "",
			showModalStatus: false,
			objs: "",
			includeGroup: "",
			objsList: [],
			brands: [], //品牌
			goodsCategorys: [],
			propertys: [], //参数
			goodsLabels: [], //商品标签
			loadType: "load",
			queryParams: {
				pageNumber: 1,
				pageSize: 8,
				goodsCategoryId: '1',
				orderType: 'TOP_DESC',
				brandId: null,
				marketingId: null,
				goodsLabelId: null,
				keyword: null,
				storeId: null,
			},
			is_filter: false,
			goodsPropertys: [],
			filterWindowId: '',
			///////////////////////////////////////////////////////////////////////////////////////////


		};
	},
	computed: {
		...mapGetters("home", ["sellerGoodsList", "categoryList"]),
	},
	activated() {
		// this.requestData();


		// if (option.id) {
		// 		this.queryParams.goodsCategoryId = option.id;
		// 	}
		// 	if (option.orderType) {
		// 		this.queryParams.orderType = option.orderType;
		// 	}
		let goodsCategoryId = this.$router.currentRoute.query.id ? this.$router.currentRoute.query.id : '1';
		// this.$router.push({ name: "commodity", query: {id:id} });
		this.queryParams.goodsCategoryId = goodsCategoryId;
		this.goods_list();

	},
	// watch: {
	//   $route(to, from) {
	//     if(to.path == '/commodity'){
	//       window.scrollTo(0, 111);
	//     }
	//     // this.windowScroll();

	//           // window.scrollTo(0, this.scrollTop);
	//   },
	// },
	methods: {
		...mapActions("home", ["requestSellerGoodsList", "requestCategoryList"]),
		changeFilter(item, index) {
			this.currentFilterValue = index;
		},
		changepage() {
			this.queryParams.pageNumber = 0;
			// this.requestData();
		},
		async requestData(params = {}) {
			try {
				const currentRouter = this.$router.currentRoute;
				const categoryId = currentRouter.query.id || params.categoryId;

				if (!categoryId && this.beforeSortParams) {
					this.loading = true;
					await this.requestSellerGoodsList({
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						...this.beforeSortParams,
					}).then((res) => {
						this.total = res.pageInfo.totalElements;
						if (this.sellerGoodsList.length) {
							this.$Gsap.fromTo(this.$refs.activeScoll, {
								delay: 0,
								duration: 1.5,
								y: "100",
								autoAlpha: 0,
								ease: "back.out(1.7)",
							}, {
								delay: 0,
								duration: 1,
								y: "0",
								autoAlpha: 1,
								ease: "back.out(1.7)",
							}
							);
						}
					});
				} else {
					const sortParams = Object.prototype.hasOwnProperty.call(
						params,
						"categoryId"
					)
						? this.beforeSortParams
						: {};
					this.loading = true;

					await this.requestSellerGoodsList({
						...sortParams,
						...params,
						categoryId,
						pageNum: this.pageNum,
						pageSize: this.pageSize,
					}).then((res) => {
						this.total = res.pageInfo.totalElements;
						if (this.sellerGoodsList.length) {
							this.$Gsap.fromTo(this.$refs.activeScoll, {
								delay: 0,
								duration: 1.5,
								y: "100",
								autoAlpha: 0,
								ease: "back.out(1.7)",
							}, {
								delay: 0,
								duration: 1,
								y: "0",
								autoAlpha: 1,
								ease: "back.out(1.7)",
							});
						}
					});
				}
			} finally {
				this.loading = false;
			}
		},
		currentChange(page) {
			this.queryParams.pageNumber = page;
			document.documentElement.scrollTop = 0;
			this.goods_list();
		},
		filterChange(data) {
			this.queryParams.pageNumber = 0;
			this.queryParams.goodsCategoryId = data.id;
			this.goods_list();
			this.isRenew = true;
		},
		// sortEvent(data) {
		// 	this.sort = data;
		// 	this.pageNum = 1;
		// 	this.beforeSortParams = data;
		// 	this.requestData(data);
		// },



		//////////////////////////////////////////////////////////////////////////////////////////////////



		goods_list() {
			this.loading = true;
			list(this.goodsPropertys, this.queryParams).then(response => {
				this.loading = false;
				this.queryParams.pageNumber = response.data.data.data.pageable.pageNumber;
				this.total = response.data.data.data.total;
				this.totalPages = response.data.data.data.totalPages;
				this.objsList = response.data.data.data.content;
				this.brands = response.data.data.data.brands;
				this.goodsCategorys = response.data.data.data.goodsCategories;
				this.propertys = response.data.data.data.propertys; //参数
				this.goodsLabels = response.data.data.data.goodsLabels; //商品标签
				this.filterWindowId = this.queryParams.goodsCategoryId;
			});
		},
		/**
		 * 搜索列表 search
		 */
		goods_search() {
			search(this.queryParams).then(response => {
				//下拉加载
				if (this.loadType === "reach") {
					const newObjsList = response.data.data.data.content;
					newObjsList.forEach(item => this.objsList.push(item));
					this.searchLoading = false;
					//加载
				} else if (this.loadType === "load") {
					this.objsList = response.data.data.data.content;
					this.brandOptions = response.data.data.brands;
					this.goodsCategoryOptions = response.data.data.goodsCategories;
					this.searchLoading = false;
					//下拉刷新
				} else if (this.loadType === "pullDown") {
					uni.stopPullDownRefresh();
				}
			});
		},
		onErrorImg(item) {
			this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
		},
		//返回
		goback: function () {
			uni.navigateBack({
				delta: 1
			});
		},
		// 传值
		onOrder: function (data) {
			if (data.type) {
				this.queryParams.orderType = data.type;
				this.queryParams.pageNumber = 1;
				this.loadType = "load";
				this.goods_list();
			}
		},
		keywordChange: function (event) {
			this.queryParams.keyword = event.detail.value;
		},

		/* 获取数据 */
		distachAttrValue: function (commodityAttr) {
			// 把数据对象的数据（视图使用），写到局部内
			var attrValueList = this.attrValueList; // 遍历获取的数据
			for (var i = 0; i < commodityAttr.length; i++) {
				for (var j = 0; j < commodityAttr[i].attrValueList.length; j++) {
					var attrIndex = this.getAttrIndex(commodityAttr[i].attrValueList[j].attrKey,
						attrValueList); // 如果还没有属性索引为-1，此时新增属性并设置属性值数组的第一个值；索引大于等于0，表示已存在的属性名的位置
					if (attrIndex >= 0) {
						// 如果属性值数组中没有该值，push新值；否则不处理
						if (!this.isValueExist(commodityAttr[i].attrValueList[j].attrValue, attrValueList[
							attrIndex].attrValues)) {
							attrValueList[attrIndex].attrValues.push(commodityAttr[i].attrValueList[j].attrValue);
						}
					} else {
						attrValueList.push({
							attrKey: commodityAttr[i].attrValueList[j].attrKey,
							attrValues: [commodityAttr[i].attrValueList[j].attrValue]
						});
					}
				}
			}
			for (var i = 0; i < attrValueList.length; i++) {
				for (var j = 0; j < attrValueList[i].attrValues.length; j++) {
					if (attrValueList[i].attrValueStatus) {
						attrValueList[i].attrValueStatus[j] = true;
					} else {
						attrValueList[i].attrValueStatus = [];
						attrValueList[i].attrValueStatus[j] = true;
					}
				}
			}
			this.attrValueList = attrValueList;
		},
		getAttrIndex: function (attrName, attrValueList) {
			// 判断数组中的attrKey是否有该属性值
			for (var i = 0; i < attrValueList.length; i++) {
				if (attrName == attrValueList[i].attrKey) {
					break;
				}
			}
			return i < attrValueList.length ? i : -1;
		},
		isValueExist: function (value, valueArr) {
			// 判断是否已有属性值
			for (var i = 0; i < valueArr.length; i++) {
				if (valueArr[i] == value) {
					break;
				}
			}
			return i < valueArr.length;
		},
		/* 选择属性值事件 */
		/* 选中 */
		selectValue: function (attrValueList, index, key, value, unselectStatus) {
			var includeGroup = [];
			if (index == this.firstIndex && !unselectStatus) {
				// 如果是第一个选中的属性值，则该属性所有值可选
				var commodityAttr = this.commodityAttr; // 其他选中的属性值全都置空
				for (var i = 0; i < attrValueList.length; i++) {
					for (var j = 0; j < attrValueList[i].attrValues.length; j++) {
						attrValueList[i].selectedValue = '';
					}
				}
			} else {
				var commodityAttr = this.includeGroup;
			}
			for (var i = 0; i < commodityAttr.length; i++) {
				for (var j = 0; j < commodityAttr[i].attrValueList.length; j++) {
					if (commodityAttr[i].attrValueList[j].attrKey == key && commodityAttr[i].attrValueList[j]
						.attrValue == value) {
						includeGroup.push(commodityAttr[i]);
					}
				}
			}
			attrValueList[index].selectedValue = value; // 判断属性是否可选
			this.attrValueList = attrValueList;
			this.includeGroup = includeGroup;
			var count = 0;
			for (var i = 0; i < attrValueList.length; i++) {
				for (var j = 0; j < attrValueList[i].attrValues.length; j++) {
					if (attrValueList[i].selectedValue) {
						count++;
						break;
					}
				}
			}
			if (count < 2) {
				// 第一次选中，同属性的值都可选
				this.firstIndex = index;
			} else {
				this.firstIndex = -1;
			}
		},
		/* 取消选中 */
		search_filter: function () {
			this.is_filter = true;
		},
		filter_handler: function () {
			this.queryParams.pageNumber = 0;
			this.loadType = "load";
			// 重新请求
			this.goods_list();
			this.is_filter = false;
		},
		filter_close: function () {
			this.is_filter = false;
		},
		filter_brand_handler(id) {
			// var id = e.currentTarget.dataset.id;
			var brands = this.brands;
			for (var i in brands) {
				if (id == brands[i].id) {
					if (brands[i].hasOwnProperty('click') == false) {
						brands[i].click = true
					} else {
						brands[i].click = !brands[i].click;
					}
					if (brands[i].click == true) {
						this.queryParams.brandId = brands[i].id;
					} else {
						delete this.queryParams.brandId;
					}
				} else {
					brands[i].click = false;
				}
			}
			this.brands = [];
			this.brands = brands;
			this.goods_list();
		},
		filter_goodsLabels_handler(id) {
			// var id = e.currentTarget.dataset.id;
			var goodsLabels = this.goodsLabels;
			for (var i in goodsLabels) {
				if (id == goodsLabels[i].id) {
					if (goodsLabels[i].hasOwnProperty('click') == false) {
						goodsLabels[i].click = true
					} else {
						goodsLabels[i].click = !goodsLabels[i].click;
					}
					if (goodsLabels[i].click == true) {
						this.queryParams.goodsLabelId = goodsLabels[i].id;
					} else {
						delete this.queryParams.goodsLabelId;
					}
				} else {
					goodsLabels[i].click = false;
				}
			}
			this.goodsLabels = [];
			this.goodsLabels = goodsLabels;
			this.goods_list();
		},
		filter_goods_category_handler(e) {
			var id = e.currentTarget.dataset.id;
			var goodsCategorys = this.goodsCategorys;
			for (var i in goodsCategorys) {
				if (id == goodsCategorys[i].id) {
					goodsCategorys[i].click = !goodsCategorys[i].click;
					if (goodsCategorys[i].click == true) {
						this.queryParams.goodsCategoryId = goodsCategorys[i].id;
					}
				} else {
					goodsCategorys[i].click = false;
					delete this.queryParams.goodsCategoryId;
				}
			}
			this.goodsCategoryOptions = [];
			this.goodsCategoryOptions = pcos;
		},
		filter_propertys_handler: function (id, value) {
			let propertys = this.propertys;
			for (let i = 0; i < propertys.length; i++) {
				if (id == propertys[i].id) {
					let options = propertys[i].options;
					//进入二级循环
					if (options && options.length > 0) {
						for (let x = 0; x < options.length; x++) {
							if (value == options[x]) {
								if (propertys[i].selectValue == value) {
									delete propertys[i].selectValue;
								} else {
									propertys[i].selectValue = value;
								}
							}
						}
					}
				}
			}
			this.propertys = [];
			this.propertys = propertys;
			this.goodsPropertys = [];
			for (let i = 0; i < propertys.length; i++) {
				if (propertys[i].selectValue) {
					this.goodsPropertys.push({
						'id': propertys[i].id,
						'value': propertys[i].selectValue
					});
				}
			}
			this.goods_list();
		},

		// sortEvent(data) {
		//   this.sort = data;
		//   this.pageNum = 1;
		//   this.beforeSortParams = data;
		// //   this.requestData(data);
		// },

		//////////////////////////////////////////////////////////////////////////////////////////////////



	},
};
</script>

<style lang="scss">
.commodity {
	&-wrap {
		align-items: flex-start;
		margin-top: -13px !important;

		ul {
			list-style: none;
			margin: 0;
			padding: 0;
		}
	}

	.commodity-wrap {
		min-height: calc(100vh - 361.5px);
	}

	&-filter {
		width: 180px;
		border-right: 1px solid var(--color-border);

		h2 {
			width: 100%;
			// text-align: center;
			font-weight: 600;
			font-size: 16px;
			color: var(--color-title);
			border-bottom: 1px solid var(--color-border);
			padding: 20px 0;
			margin-bottom: 20px;
		}

		&-item {
			// text-align: center;
			width: 100%;
			font-weight: 400;
			font-size: 14px;
			color: var(--color-black);
			padding: 12px 0;
			cursor: pointer;

			&:hover {
				color: var(--color-main);
				border-right: 2px solid var(--color-main);
			}

			&-active {
				color: var(--color-main);
				border-right: 2px solid var(--color-main);
			}
		}
	}

	&-content {
		width: 100%;

		&-list {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
			grid-column-gap: 11px;
			grid-row-gap: 20px;
			align-content: center;
			padding: 22px 28px;
		}

		&-pagination {
			width: 100%;
			text-align: center;
			padding: 40px 0;
		}
	}

	.no-data {
		display: flex;
		justify-content: center;
	}
}
</style>
